<template>
  <div class="activity-english">
    <web-header language="en" ref="webHeaderRef"></web-header>
    <div class="activity-english-wrap">
      Waiting for development
    </div>
    <web-footer language="cn"></web-footer>
    <el-backtop></el-backtop>
  </div>
</template>
<script>
import WebHeader from "@/components/webHeader";
import WebFooter from "@/components/webFooter";
export default {
  name: 'ActivityEnglish',
  components: {
    WebHeader,
    WebFooter,
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
<style scoped lang="scss">
.activity-english {
  &-wrap {
    width: 50%;
    margin: 50px auto 80px auto;
    height: 800px;
  }
}
</style>
